export default __webpack_public_path__ + "static/media/3-OFFICIEL.a6ebc8f5.pdf";